// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2yigQ{background-color:#fff;border-radius:8px;bottom:120%;-webkit-box-shadow:0 4px 20px 0 rgba(50,66,121,.5);box-shadow:0 4px 20px 0 rgba(50,66,121,.5);left:50%;min-width:172px;padding:12px;position:absolute;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}._2C4vo{cursor:pointer;fill:#30a8ff;height:12px;position:absolute;right:12px;top:12px;width:12px;z-index:1}", ""]);
// Exports
exports.locals = {
	"tooltip": "_2yigQ",
	"tooltip__close": "_2C4vo"
};
module.exports = exports;
